// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"77b8534a","5071":"8c9c231e","5938":"87a5d297","6199":"3c7ab29a","6257":"68f70b23","7829":"87a5d297","7878":"830c8e0f","9164":"830c8e0f","9265":"87a5d297"}[chunkId] + ".chunk.css";
};